import React, { Component } from 'react';
import { BrowserRouter as Brouter } from 'react-router-dom'
import { Provider } from "react-redux";
import store from "../redux/store";
import "../global/css/App.css";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { EstiloApp } from "./general/EstiloApp";
import Principal from "./general/app/Principal";
//MENSAJE
import Mensajes from './general/Mensajes'
import Question from './general/BotonQuestion'
import ReactNotifications from 'react-notifications-component';
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { Helmet } from "react-helmet";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { mostrarPruebas: true };
  }

  render() {
    const isProd = process.env.REACT_APP_ENV === "production";

    return (
      <Provider store={store}>
        <ReactNotifications />

        <Helmet>
          <title>{isProd ? "emma" : "emmaTest"}</title>

          {!isProd && (
            <meta name="robots" content="noindex, nofollow" />
          )}

          <meta
            name="description"
            content={
              isProd
                ? "La plataforma EMMA de la Universidad de la Costa CUC es un entorno digital de acceso académico donde los estudiantes pueden gestionar sus procesos académicos, como ingreso a servicios, trámites, consultas y otras gestiones relacionadas con su vida universitaria."
                : "Entorno de pruebas Emma"
            }
          />
        </Helmet>

        <Brouter>
          <MuiThemeProvider theme={EstiloApp}>
            <div id='fondo_pantalla'>
              <Principal />
              {!isProd && this.state.mostrarPruebas &&
                <Snackbar
                  open={this.state.mostrarPruebas}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }} // esquina inferior derecha
                >
                  <MuiAlert elevation={6} variant="filled" onClose={() => this.setState({ mostrarPruebas: false })} severity="warning" >
                    Estás navegando en un ambiente de pruebas. Los datos aquí son simulados y cualquier cambio realizado no tendrá efectos en producción.
                  </MuiAlert>
                </Snackbar>

              }
            </div>
            <Question setbBtnPreguntas={(btnPreguntas) => this.setState({ btnPreguntas })} />
            <Mensajes />
          </MuiThemeProvider>
        </Brouter>
      </Provider>
    );
  }
}


export default (App);

